  function homeBrandCards(limit){
    var brands=(cfg.appBrands||[]).slice(0,Number(limit||6));
    return '<div class="lmp-brand-grid lmp-brand-logo-grid lmp-home-brand-grid">'+brands.map(function(b){
      return '<a class="lmp-brand lmp-brand--logo" href="'+esc(appUrl(b.url))+'" data-lmp-link aria-label="'+esc(b.name)+'">'+
        (b.logo?'<img class="lmp-brand__logo" src="'+esc(b.logo)+'" alt="'+esc(b.name)+'" loading="lazy" onerror="this.hidden=true;this.nextElementSibling.hidden=false">':'')+
        '<span class="lmp-brand__fallback" '+(b.logo?'hidden':'')+'>'+esc(b.name)+'</span></a>';
    }).join('')+'</div>';
  }

  function renderHomeBestSellers(){
    var el=document.getElementById('lmp-home-best-sellers');if(!el)return;
    var products=cfg.bestSellers||[];
    if(products.length){
      el.innerHTML='<div class="lmp-products">'+products.slice(0,8).map(function(p){return productCard(p,true)}).join('')+'</div>';
      return;
    }
    fetch('/collections/meilleurs-ventes/products.json?limit=8&_='+Date.now(),{credentials:'same-origin',headers:{'Accept':'application/json','Cache-Control':'no-cache'}})
      .then(function(r){if(!r.ok)throw new Error('best sellers');return r.json()})
      .then(function(data){
        var ps=collectionProductsToCards(data.products||[]);
        el.innerHTML=ps.length?'<div class="lmp-products">'+ps.slice(0,8).map(function(p){return productCard(p,true)}).join('')+'</div>':'<div class="lmp-empty"><strong>Produits bientôt disponibles</strong>La sélection des meilleures ventes est en cours de mise à jour.</div>';
        if(typeof window.lmpMarkDataFresh==='function')window.lmpMarkDataFresh();
      })
      .catch(function(){el.innerHTML='<div class="lmp-empty"><strong>Chargement impossible</strong>Réessayez dans quelques instants.</div>';});
  }

  function renderHome(){
    var first=(cfg.customer&&cfg.customer.firstName)?' '+esc(cfg.customer.firstName):'';
    var content=topbar(false)+
      '<section class="lmp-greeting"><small>Bonjour'+first+' 👋</small><h1>Prenez soin de vous</h1><p>Beauté, santé et bien-être au quotidien</p></section>'+
      searchBox('')+
      '<a class="lmp-hero" href="'+esc(appUrl('/collections/protections-solaires'))+'" data-lmp-link>'+
        '<img src="'+esc((cfg.categoryImages||{}).solaire||'')+'" alt="" fetchpriority="high">'+
        '<div class="lmp-hero__content"><div class="lmp-hero__eyebrow">Protection solaire</div><h2>Solaire</h2><p>Une peau protégée, partout au Maroc.</p><span class="lmp-pill-btn">Découvrir →</span></div>'+
      '</a>'+
      '<section class="lmp-section"><div class="lmp-section__head"><h2>Explorer</h2><a href="'+esc(appUrl('/pages/categories-parapharmacie'))+'" data-lmp-link>Voir tout</a></div>'+categoryCards(false)+'</section>'+
      '<section class="lmp-section lmp-home-brands"><div class="lmp-section__head"><div><small>Nos références</small><h2>Marques populaires</h2></div><a href="'+esc(appUrl('/pages/marques'))+'" data-lmp-link>Voir toutes</a></div>'+homeBrandCards(6)+'</section>'+
      '<section class="lmp-section lmp-home-best-sellers"><div class="lmp-section__head"><div><small>Les favoris de nos clients</small><h2>Produits les plus vendus</h2></div><a href="'+esc(appUrl('/collections/meilleurs-ventes'))+'" data-lmp-link>Voir tout</a></div><div id="lmp-home-best-sellers">'+skeleton()+'</div></section>';
    shell(content);
    renderHomeBestSellers();
  }
  function renderCategories(){
    var content=topbar(false)+'<div class="lmp-page-head"><div class="lmp-page-head__copy"><h1 class="lmp-page-title">Catégories</h1><small>Trouvez vos soins en quelques secondes</small></div></div>'+
      categoryCards(true)+
      '<section class="lmp-section"><div class="lmp-section__head"><h2>Marques populaires</h2><a href="'+esc(appUrl('/pages/marques'))+'" data-lmp-link>Toutes</a></div>'+
      '<div class="lmp-brand-grid">'+['La Roche-Posay','CeraVe','Eucerin','Vichy','Bioderma','ISDIN'].map(function(n,i){
        var handles=['la-roche-posay-prix-maroc-parapharmacie','cerave-prix-maroc-parapharmacie','eucerin-prix-maroc','vichy-prix-maroc-parapharmacie','bioderma-prix-maroc','isdin-prix-maroc'];
        return '<a class="lmp-brand" href="'+esc(appUrl('/collections/'+handles[i]))+'" data-lmp-link>'+esc(n)+'</a>'
      }).join('')+'</div></section>';
    shell(content);
  }
  function renderBrands(){
    var brands=[
      ['La Roche-Posay','la-roche-posay-prix-maroc-parapharmacie'],['CeraVe','cerave-prix-maroc-parapharmacie'],
      ['Eucerin','eucerin-prix-maroc'],['Vichy','vichy-prix-maroc-parapharmacie'],['Bioderma','bioderma-prix-maroc'],
      ['ISDIN','isdin-prix-maroc'],['Avène','avene-prix-maroc'],['Uriage','uriage'],['Ducray','ducray-prix-maroc'],
      ['Filorga','filorga'],['ACM','acm-prix-maroc']
    ];
    var content=topbar(true)+'<div class="lmp-page-head"><div class="lmp-page-head__copy"><h1 class="lmp-page-title">Marques</h1><small>Les marques les plus demandées</small></div></div>'+
      '<div class="lmp-brand-grid">'+brands.map(function(b){return '<a class="lmp-brand" href="'+esc(appUrl('/collections/'+b[1]))+'" data-lmp-link>'+esc(b[0])+'</a>'}).join('')+'</div>';
    shell(content);
  }
  function skeleton(){
    return '<div class="lmp-loading-grid"><div class="lmp-skeleton"></div><div class="lmp-skeleton"></div><div class="lmp-skeleton"></div><div class="lmp-skeleton"></div></div>';
  }
  function titleFromHandle(handle){
    var m={
      'protections-solaires':'Solaire','visage':'Visage','soins-cheveux':'Cheveux','corps':'Corps',
      'la-roche-posay-prix-maroc-parapharmacie':'La Roche-Posay','cerave-prix-maroc-parapharmacie':'CeraVe',
      'eucerin-prix-maroc':'Eucerin','vichy-prix-maroc-parapharmacie':'Vichy','bioderma-prix-maroc':'Bioderma',
      'isdin-prix-maroc':'ISDIN','avene-prix-maroc':'Avène','uriage':'Uriage','ducray-prix-maroc':'Ducray',
      'filorga':'Filorga','acm-prix-maroc':'ACM'
    };
    return m[handle]||handle.split('-').map(function(x){return x?x.charAt(0).toUpperCase()+x.slice(1):''}).join(' ');
  }
  function collectionProductsToCards(products){
    return products.map(function(p){
      var vars=p.variants||[];
      var prices=vars.map(function(v){return parseFloat(v.price||0)}).filter(function(n){return !isNaN(n)});
      var price=prices.length?Math.min.apply(Math,prices):0;
      var compares=vars.map(function(v){return parseFloat(v.compare_at_price||0)}).filter(function(n){return n>price});
      return {title:p.title,vendor:p.vendor,handle:p.handle,url:'/products/'+p.handle,image:(p.images&&p.images[0]?p.images[0].src:''),price:price,compareAtPrice:compares.length?Math.min.apply(Math,compares):0,available:vars.some(function(v){return v.available!==false})};
    });
  }
